module.exports = __webpack_public_path__ + "img/guide-photo-one.c547bdfc.svg";